import { Assets } from "../list/Assets";
import { supabase } from "../../lib/supabaseClient";
import Gridcom from "./Gridcom";
import { searchInValue } from "./Logocom";

function recentGames() { return []; }

function search_result() {
  var input, filter, search_result, s_h2, Recent_games;
  var count = 0;
  var i;
  search_result = document.getElementsByClassName("Search_game_container");
  s_h2 = document.getElementsByClassName("s_h2");
  Recent_games = document.getElementsByClassName("Recent_games");
  search_result[0].style.display = "grid";
  input = document.getElementsByClassName("Search_Feild");

  filter = input[0].value.toUpperCase();
  while (search_result[0].lastElementChild) {
    search_result[0].removeChild(search_result[0].lastElementChild);
  }
  
  // Supabase implementation
  if (filter.length > 0 && filter !== " ") {
    supabase
      .from('bestgamespot_games')
      .select('title, slug, thumb')
      .ilike('title', `%${filter}%`)
      .limit(10)
      .then(({ data }) => {
        while (search_result[0].lastElementChild) {
          search_result[0].removeChild(search_result[0].lastElementChild);
        }
        
        if (data && data.length > 0) {
          Recent_games[0].style.display = "none";
          data.forEach(game => {
            var a = document.createElement("a");
            a.classList.add("s_thumb");
            var b = document.createElement("span");
            b.classList.add("s_title");
            var c = document.createElement("div");
            c.classList.add("s_cover");
            a.href = "/game/" + game.slug;
            a.setAttribute("title", game.title);
            b.innerHTML = game.title;
            a.appendChild(b);
            a.appendChild(c);
      
            var d = document.createElement("img");
            d.classList.add("thumb-img");
            d.setAttribute("decoding", "async");
            d.setAttribute("loading", "lazy");
            d.setAttribute("alt", game.title);
            d.setAttribute("title", game.title);
            d.setAttribute("src", game.thumb);
            d.style.color = "transparent";
      
            a.appendChild(d);
            search_result[0].appendChild(a);
          });
          search_result[0].style.display = "grid";
        } else {
          // Log missing query
          fetch('/api/log-missing-query', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ query: filter })
          }).catch(console.error);
        }

      });
  }
}


function search_close() {
  searchInValue(false);
  var logo_down = document.getElementsByClassName("logo-down");
  var Feild = document.getElementsByClassName("Search_Feild");
  var Recent_games = document.getElementsByClassName("Recent_games");
  var s_h2 = document.getElementsByClassName("s_h2");
  var Search_div = document.getElementsByClassName("Search_div");
  var black_screen = document.getElementById("black_screen");
  var count = 0;
  Feild[0].value = "";
  var search = document.getElementsByClassName("Search_game_container");
  while (search[0].lastElementChild) {
    search[0].removeChild(search[0].lastElementChild);
  }
  Recent_games[0].style.display = "grid";
  search[0].style.display = "none";

  s_h2[0].innerHTML = "New Games";
  count = 0;
  Search_div[0].className = "Search_div Sout";
  black_screen.style.display = "none";
  logo_down[0].className = "logo-down down backtodown";
  document.body.style.overflow = "auto";
}

export default function Searchcom(props) {
  return (
    <></>
    // <div className="Search_div">
    //   <div className="Search_container" role={"search"}>
    //     <div className="Search_input_div">
    //       <div className="Search_input">
    //         <input
    //           className="Search_Feild"
    //           placeholder="Enter Your Dream Game Name"
    //           type={"search"}
    //           onKeyUp={search_result}
    //         ></input>
    //       </div>
    //       <div className="Search_icon">
    //         <img
    //           className="s_icon"
    //           decoding="async"
    //           alt="search icon"
    //           title="search icon"
    //           src={Assets[0].s_icon}
    //         ></img>
    //       </div>
    //     </div>
    //     <div className="Search_close" onClick={search_close}>
    //       <img
    //         className="c_icon"
    //         decoding="async"
    //         alt="search close icon"
    //         title="search close icon"
    //         src={Assets[0].c_icon}
    //       ></img>
    //     </div>
    //   </div>
    //   <h2 className="s_h2">New Games</h2>
    //   <div className="Recent_games" style={{ display: "grid" }}>
    //     {recentGames()}
    //   </div>
    //   <div className="Search_game_container" style={{ display: "grid" }}></div>
    // </div>
  );
}
